import COLORS from '../../style/universal.color';
import Handler from '../../commonTypes/handler.types';
import DefaultProps from '../../commonTypes/defaultprops.types';

// Props for the Link Component
export interface LinkProps extends DefaultProps {
  type?: LinkTypes;
  url: string;
  decoration?: LinkDecorationTypes;
  target?: string;
  rel?: string;
  download?: boolean;
  downloadName?: string;
  children?: any;
  handlers?: Handler;
  ref?: LinkRef;
}

// Decoration types for the link
export enum LinkDecorationTypes {
  NONE = 'none',
  UNDERLINE = 'underline',
  DOTTED = 'dotted'
}

// The props passed to the <a> element
export interface LinkAnchorProps {
  href: string | undefined;
  target?: string | undefined;
  rel?: string | undefined;
  className?: string | undefined;
  download?: string | boolean | undefined;
}

// Types used for Styling the Link
export enum LinkTypes {
  PRIMARY = 'primary',
  SECONDARY = 'secondary'
}

// The color theme for the link
export const LinkColors: object = {
  primary: {
    base: COLORS.linkBlue,
    hover: COLORS.starsBlue
  },
  secondary: {
    base: COLORS.mlbGrey4,
    hover: COLORS.linkBlue
  },
  dark: {
    base: COLORS.linkBlueOnDark,
    hover: COLORS.linkBlue
  }
}

export type LinkRef = React.Ref<HTMLElement>
